export enum CalculationContactSortEnum {
  Id = 'id',
  CreatedAt = 'createdAt',
  Content = 'content',
}
